import React from "react";
import "./HeroSection.css";

const BASE = process.env.PUBLIC_URL || "";

export default function HeroSection() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero__inner">
        <div className="hero__art" aria-hidden="true">
          {/* Headline centered with equal top/bottom gap */}
          <div className="hero__headline" dir="rtl">
            <h1 id="hero-title">
              من التعافي إلى النمو <br />
              <span className="free">تحرّر</span> يقودك بخطوات عملية
            </h1>
          </div>

          {/* main phone */}
          <img
            className="hero__phone"
            src={`${BASE}/assets/mobileScreen1.png`}
            alt=""
            loading="eager"
            decoding="async"
          />

          {/* floating cards */}
          <img className="hero__card card--a" src={`${BASE}/assets/floatCard1.png`} alt="" />
          <img className="hero__card card--b" src={`${BASE}/assets/heroCard2.png`}  alt="" />
          <img className="hero__card card--c" src={`${BASE}/assets/heroCard1.png`}  alt="" />
          <img className="hero__card card--d" src={`${BASE}/assets/floatCArd2.png`} alt="" />
        </div>
      </div>
    </section>
  );
}
